import Alpine from 'alpinejs';

Alpine.data('infoModal', () => ({
  isOpen: false,
  init() {
    const val = this.get();

    if (!val) {
      this.set();

      this.isOpen = true;
    }
  },
  closeModal() {
    this.isOpen = false;
  },
  set() {
    console.log('xdxd set');
    localStorage.setItem('hasBeenInformed', '1');
  },
  get() {
    const itemStr = localStorage.getItem('hasBeenInformed');

    if (!itemStr) {
      return null;
    }

    return itemStr;
  },
}));
